import React from 'react';
import {MasterLayout} from 'components/layouts';
import {FavoriteProductContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class FavoriteProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.FavoriteProduct;
  }

  render() {
    return (
      <MasterLayout>
        <FavoriteProductContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(FavoriteProduct);



// WEBPACK FOOTER //
// ./pages/users/FavoriteProduct.jsx